import Api from './Api';

export default {
  //Usage -  ForgotPassword({
  //     email: payload.email
  //   })
  ForgotPassword(payload) {
    return Api().post('/api/external/website-forgot-password', payload);
  },
  //   Usage  -   MovieService.ChangePassword({
  //     otp: payload.otp,
  //     password: payload.password,
  //     cust_id: state.reset_pass_data.cust_id,
  //     email: state.reset_pass_data.cust_email,
  //     first_name: state.reset_pass_data.first_name
  //   })
  ChangePassword(payload) {
    return Api().post('/api/external/website-change-password', payload);
  },
  GetAllNationality() {
    return Api().get('/api/external/get-nationalities');
  },
};
